<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	
	const emit = defineEmits(['nextStep', 'updateForm']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/selection" }
	});
	
	const { errorMessage, isError, progress, sendForm, nextStep } = useBaseStep(props,emit,validateForm);
	
	function validateForm(): boolean {
		return true;
	}
	
	function submit(): void {
		sendForm(props.form,props.form.selection==='install'?'Database':'Upgrade')
	}
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.selection.selectInstalation")}}</div>
	<form @submit.prevent>
		<table border="0" cellspacing="0" class="formTable">
			<tr>
				<td><label><input type="radio" name='selection' :checked="form.selection==='install'"
					@input="$emit('updateForm', 'selection', $event.target.value)" value="install" tabindex="10">
						&nbsp;{{msg("install.installNew")}}</label></td>
			</tr>
			<tr>
				<td><label><input type="radio" name='selection' :checked="form.selection==='upgrade'"
					@input="$emit('updateForm', 'selection', $event.target.value)" value="upgrade" tabindex="20">
						&nbsp;{{msg("install.installUpgrade")}}</label></td>
			</tr>
			<tr>
				<td><error-msg :show="isError" :msg="errorMessage"/></td>
			</tr>
			<tr>
				<td style="padding-top:10px">
					<button @click="nextStep('Language')" class="sbutton">
						<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
					</button>
					&nbsp;
					<progress-button @click="submit" :progress="progress" tabindex="30"
						class="button" icon="page-next-16-full">
						{{msg('install.butt.next')}}
					</progress-button>
				</td>
			</tr>
		</table>
	</form>
	</div>
</template>

